'use client'

import { AuthContext } from "@/context/authContext"
import { with_comma } from "@/util/comma";
import { useContext } from "react"
import FloatDialog from "./_floatDialog";
import { SignContext } from "@/context/signContext";

import InqueryFooter from "../etc/inqueryFooter";
import { NavContext } from "@/context/navContext";
import { useRouter } from "next/navigation";
import { BetContext } from "@/context/BetContext";
import { MessageContext } from "@/context/messageContext";
import ProfileLayout from "@/components/etc/profile";
import customAlert from "@/util/customAlert";
import { useTranslations } from "next-intl";

export default function FloatMypage() {
    const { mypageShow, SetMypageShow, SetPasswordShow, setChangeProfileShow } = useContext(SignContext)
    const { user, logout, messages } = useContext(AuthContext)
    const { setBetDetailShow } = useContext(BetContext)
    const { SetMessageShow } = useContext(MessageContext)
    const router = useRouter()

    const t = useTranslations('Text')

    function movePage(path: string) {
        SetMypageShow(false);
        router.push(path)
    }

    function handleLogout() {
        SetMypageShow(false)
        logout()
    }

    if (!user.is_authenticated) return null;

    return (
        <FloatDialog
            show={mypageShow}
            setShow={SetMypageShow}
            className="mypage" >
            <FloatDialog.Head>{t('마이페이지')}</FloatDialog.Head>
            <FloatDialog.Body>
                <div className="float-mypage-container">
                    <div className="mypage-inner">

                        <div className={`login-auth-new m-b-20`}>
                            <div className={`flex center`}>
                                <div className={`img`}><ProfileLayout /></div>
                                <div className={`info`}>
                                    <div className={`flex center`}>
                                        <div className={`w-20-per`}>{t('아이디')}</div>
                                        <div className={`w-80-per p-l-10`}>{user.id}</div>
                                    </div>
                                    <div className={`flex center`}>
                                        <div className={`w-20-per`}>{t('닉네임')}</div>
                                        <div className={`w-80-per p-l-10`}>{user.nickname}</div>
                                    </div>
                                    <div className={`flex center etc`}>
                                        <div className={`w-33-per`}>
                                            <div>{t('레벨')}</div>
                                            <div>{with_comma(user.level)}</div>
                                        </div>
                                        <div className={`w-33-per`}>
                                            <div>{t('경험치')}</div>
                                            <div>{with_comma(user.exp)} EXP</div>
                                        </div>
                                        <div className={`w-33-per`}>
                                            <div>{t('포인트')}</div>
                                            <div>{with_comma(user.point)} P</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="btns">

                            {/* 그리드맞춰놓고 모바일 체크 하셔야합니다이잇 박스 넘어가버립니다요잇 */}
                            <div className="col2">
                                <button onClick={e=> SetMessageShow(true)}>{t('쪽지함')}</button>
                                <button onClick={e=> movePage('/pointexchange/sponmd/')}>{t('포인트 전환')}</button>
                                <button onClick={e => SetPasswordShow(true)}>{t('비밀번호 변경')}</button>
                                <button onClick={handleLogout}>{t('로그아웃')}</button>
                            </div>
                        </div>
                    </div>
                    <InqueryFooter />
                    <div className="btns">
                        <button className="theme" onClick={e => movePage('/verified')}>{t('스폰업체 바로가기')}</button>
                    </div>
                </div>
            </FloatDialog.Body>
        </FloatDialog>
    )
}